module.exports = {"id":"241461","name":"Ferrán Torres","rating":"71","photo":"./data/images/photos/2/241461.png","club":{"name":"Valence CF","logo":"./data/images/clubs/ValenceCF.png"},"positions":["MD","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FerranTorres0.json
// module id = 1429
// module chunks = 0